import {
  ROLE_KEYS,
  getFlatMenuItems,
  getRolePermissions,
} from "../../utils/rbac.js";

export function createEmptyAccountDraft() {
  return {
    email: "",
    name: "",
    avatar: "",
    role: ROLE_KEYS.ADMIN,
    status: "active",
    permissions: {},
  };
}

function normalizePermissionEntry(entry) {
  if (entry === true) {
    return { visible: true, editable: true };
  }
  if (entry === false) {
    return { visible: false, editable: false };
  }
  return {
    visible: Boolean(entry?.visible),
    editable: Boolean(entry?.editable),
  };
}

export function buildPermissionRows(accountDraft) {
  const rolePermissions = getRolePermissions(accountDraft?.role);
  const customPermissions = accountDraft?.permissions || {};

  return getFlatMenuItems().map((item) => {
    const roleEntry = normalizePermissionEntry(rolePermissions[item.permissionKey]);
    const customEntry = customPermissions[item.permissionKey]
      ? normalizePermissionEntry(customPermissions[item.permissionKey])
      : null;
    const permission = customEntry || roleEntry;

    return {
      section: item.section,
      label: item.label,
      path: item.path,
      permissionKey: item.permissionKey,
      visible: permission.visible,
      editable: permission.editable,
    };
  });
}

export function buildSavePayload(accountDraft, permissionRows) {
  const permissions = permissionRows.reduce((result, row) => {
    result[row.permissionKey] = {
      visible: Boolean(row.visible),
      editable: Boolean(row.visible && row.editable),
    };
    return result;
  }, {});

  return {
    email: (accountDraft.email || "").trim(),
    name: accountDraft.name || "",
    avatar: accountDraft.avatar || "",
    role: accountDraft.role,
    status: accountDraft.status || "active",
    permissions,
  };
}
